module.exports = __webpack_public_path__ + "static/media/banner1.480da242.jpg";